module.exports = __webpack_public_path__ + "img/My_Friend_Mr_Brooks.d2ca9d78.jpg";